<template>
    <div :class="['BaseTextarea__container',className]">
        <i v-if="icon" :class="['BaseTextarea__icon',icon]"></i>
        <div class="BaseTextarea" :class="{'BaseTextarea_error':(errors && errors.length>0)}">
            <textarea type="text" 
                   required 
                   class="BaseTextarea__input" 
                   :autofocus="autofocus ? true : false" 
                   :rows="rows" 
                   :value="value" 
                   @change="change($event)"></textarea>
            <label class="BaseTextarea__label_after" v-once>{{translate(label)}}</label>
            <span class="BaseTextarea__bar"></span>
            <BaseErrors :errors="errors"/>
        </div>
    </div>
</template>

<script>
    import BaseErrors from './BaseErrors.vue';

    export default {
        name: 'BaseTextarea',
        components: {
            BaseErrors
        },
        props: {
            //The label of the textbox
            label: {
                type: String
            },
            //Input value of textbox
            value: {
                type: String
            },
            //Form validation errors
            errors: {
                type: Array
            },
            //If true the textbox will get focus
            autofocus: {
                type: Boolean
            },
            //Number of rows
            rows: {
                type: Number
            },
            //Additional css class name for styling
            className: {
                type: String
            },
            //Icon class
            icon: {
                type: String
            }
        },
        methods: {
            change: function (e) {
                this.$emit('change', e);
            }
        }
    };
</script>

<style>
    .BaseTextarea__container {
        display: flex;
        flex-direction: row;
        margin: 10px 0;
    }

    .BaseTextarea {
        position: relative;
        flex: 1 1 auto;
    }

    .BaseTextarea_error .BaseTextarea__bar, .BaseTextarea_error .BaseTextarea__label, .BaseTextarea_error .BaseTextarea__label_after {
        color: #cc4a4a;
    }

    .BaseTextarea_error .BaseTextarea__input {
        border-bottom: 1px solid #cc4a4a;
    }

    .BaseTextarea__icon {
        color: rgba(96, 125, 139, 0.7);
        font-size: 24px;
        margin: 4px 8px 0 4px;
    }

    .BaseTextarea__input {
        font-family: Roboto,sans-serif;
        width: 100%;
        font-size: 16px;
        padding: 8px 8px 4px 0;
        display: block;
        outline: none;
        border: none;
        border-bottom: 1px solid rgba(96, 125, 139, 0.4);
        box-shadow: none;
        background-color: transparent;
    }

        .BaseTextarea__input.has-icon {
            padding-left: 16px
        }

        .BaseTextarea__input :focus {
            outline: none;
        }

        .BaseTextarea__input:invalid {
            box-shadow: none;
        }

        .BaseTextarea__input[type=number] {
            text-align: right;
        }

    /* label */
    .BaseTextarea__label_after {
        white-space: nowrap;
        display: block;
        color: rgba(96, 125, 139, 0.7);
        font-size: 18px;
        font-weight: 400;
        position: absolute;
        pointer-events: none;
        top: 7px;
        transition: all .2s ease;
        -moz-transition: .2s ease all;
        -webkit-transition: all .2s ease;
    }

        .BaseTextarea__label_after.has-icon {
            left: 16px;
        }

    .BaseTextarea__input:focus ~ .BaseTextarea__label_after {
        top: -12px;
        font-size: 14px;
        color: rgb(96, 125, 139);
    }

    .BaseTextarea__input:valid ~ .BaseTextarea__label_after {
        top: -12px;
        font-size: 14px;
    }

    .BaseTextarea__bar {
        position: relative;
        display: block;
    }

        .BaseTextarea__bar:after, .BaseTextarea__bar:before {
            content: "";
            height: 2px;
            width: 0;
            bottom: 0;
            position: absolute;
            background: rgba(96, 125, 139, 0.7);
            transition: all .2s ease;
            -moz-transition: .2s ease all;
            -webkit-transition: all .2s ease;
        }

        .BaseTextarea__bar:before {
            left: 50%;
        }

        .BaseTextarea__bar:after {
            right: 50%;
        }

    /* active state */
    .BaseTextarea__input:focus ~ .BaseTextarea__bar:after, .BaseTextarea__input:focus ~ .BaseTextarea__bar:before {
        width: 50%;
    }
</style>



// WEBPACK FOOTER //
// BaseTextarea.vue?b4a4464e